export type OrderingColumnKey =
  | 'supplier'
  | 'category'
  | 'photo'
  | 'orderingDescription'
  | 'notebook'
  | 'qty'
  | 'clientProject'
  | 'itemRoom'
  | 'wo'
  | 'invoice'
  | 'url'
  | 'uploads'
  | 'purchaser'
  | 'itemStatus'
  | 'installDate'
  | 'dueDate'
  | 'customColumn1'
  | 'customColumn2'
  | 'customColumn3'
  | 'orderedDate'
  | 'receivedDate';

export type OrderingColumnVisibility = Partial<Record<OrderingColumnKey, boolean>>;

export const ORDERING_COLUMNS: { key: OrderingColumnKey; label: string }[] = [
  { key: 'supplier', label: 'Supplier' },
  { key: 'category', label: 'Category / Subcategory' },
  { key: 'photo', label: 'Photo' },
  { key: 'orderingDescription', label: 'Ordering Description ' },
  { key: 'notebook', label: 'Notebook' },
  { key: 'qty', label: 'Qty' },
  { key: 'clientProject', label: 'Client \ Parent' },
  { key: 'itemRoom', label: 'Item \ Room' },
  { key: 'wo', label: 'WO' },
  { key: 'invoice', label: 'Invoice' },
  { key: 'url', label: 'URL' },
  { key: 'uploads', label: 'Uploads' },
  { key: 'purchaser', label: 'Purchaser' },
  { key: 'itemStatus', label: 'Item Status' },
  { key: 'installDate', label: 'Install Date ' },
  { key: 'dueDate', label: 'Due Date' },
  { key: 'customColumn1', label: 'Custom Field 1' },
  { key: 'customColumn2', label: 'Custom Field 2' },
  { key: 'customColumn3', label: 'Custom Field 3' },
  { key: 'orderedDate', label: 'Ordered & PO #' },
  { key: 'receivedDate', label: 'Received & ETA date' },
];

export const DEFAULT_ORDERING_COLUMN_VISIBILITY: Record<OrderingColumnKey, boolean> = {
  supplier: true,
  category: true,
  photo: true,
  orderingDescription: true,
  notebook: true,
  qty: true,
  clientProject: true,
  itemRoom: true,
  wo: true,
  invoice: true,
  url: true,
  uploads: true,
  purchaser: true,
  itemStatus: true,
  installDate: true,
  dueDate: true,
  customColumn1: false,
  customColumn2: false,
  customColumn3: false,
  orderedDate: true,
  receivedDate: true,
};

export const resolveColumnVisibility = (
  visibility?: OrderingColumnVisibility
): Record<OrderingColumnKey, boolean> => ({
  ...DEFAULT_ORDERING_COLUMN_VISIBILITY,
  ...(visibility ?? {}),
});

export const isColumnVisible = (
  visibility: OrderingColumnVisibility | undefined,
  key: OrderingColumnKey
): boolean => visibility?.[key] !== false;
